<template>
  <b-modal
    hide-footer
    id="modal-digital-id-company"
    ref="modal-digital-id-company"
    size="xl"
    title="เพิ่มข้อมูล"
  >
    <iframe
      :src="
        `${digitalIdUrl}Company/FullPageManage?AuthId=${authId}&id=${compId}&time=${Date.now()}`
      "
      id="i-frame"
      width="100%"
      height="800"
      frameborder="0"
      crossorigin
    >
    </iframe>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BForm,
  BButton,
  BFormTextarea,
  BFormDatepicker,
} from "bootstrap-vue";

import vSelect from "vue-select";
import { VueAutosuggest } from "vue-autosuggest";
import * as ComplaintAPI from "@/store/api/complaint/complaint.js";
import * as lang from "vuejs-datepicker/src/locale";
import * as userData from "@/auth/localStorageUtils.js";
import appsettings from "@/store/app-settings";

export default {
  components: {
    BRow,
    BCol,
    BFormDatepicker,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    vSelect,
    VueAutosuggest,
    ComplaintAPI,
    lang,
    userData,
  },
  data() {
    return {
      authId: "",
      digitalIdUrl: "",
    };
  },
  props: {
    compId: {
      type: String,
    },
  },
  computed: {
    identityState() {
      return this.personal.identity.length === 13 ? true : false;
    },
  },
  methods: {
    iframeSubmit(event) {
      //console.log("event.data", event.data);
      if (event.data.type === "submit") {
        //console.log('iframe event submit', event.data)
        this.$emit("handle-success", event.data.data.id);
      } else if (event.data.type === "cancel") {
        console.log("iframe event cancel");
        this.$refs["modal-digital-id-company"].hide();
      }
    },
  },
  created() {
    //console.log('created', this)
  },
  mounted() {
    //console.log('mounted')
    window.addEventListener("message", this.iframeSubmit);
    this.authId = userData.userId();
    this.digitalIdUrl = appsettings.digitalIdBackendUrl;
  },
};
</script>

<style></style>
